import request from '@/utils/request'

export function getPayments(branch_id) {
  return request({
    url: 'payment/payments/'+branch_id,
    method: 'get'
  });
}
